import UserMenuItem from "./UserMenuItem";
import i18nPackage from "../../i18n/i18n";
import InstitutionIcon from "./images/institution.svg?react";
import DisabledInstitutionIcon from "./images/disabled-institution.svg?react";
import InstallIcon from "./images/install.svg?react";
import ApplicationsIcon from "./images/applications.svg?react";
import LiveProctoringIcon from "./images/live-proctoring.svg?react";
import FeedbackIcon from "./images/feedback.svg?react";
import EventsIcon from "./images/events.svg?react";
import AccountManagerIcon from "./images/account-manager.svg?react";

const ALL_ADMIN_MENU_ITEMS = [
	"institutions",
	"install",
	"accountManager",
	"applications",
	"proctor",
	"feedback",
	"events",
	"pendingInstitutionDeletion",
	"auditLogs",
] as const;

export type AdminMenuItem = (typeof ALL_ADMIN_MENU_ITEMS)[number];

type AdminUserMenuItemsProps = {
	onMenuItemClick: (menuItem: AdminMenuItem) => void;
	visibleMenuItems?: readonly AdminMenuItem[];
};

export default function AdminUserMenuItems({
	onMenuItemClick,
	visibleMenuItems = ALL_ADMIN_MENU_ITEMS,
}: AdminUserMenuItemsProps) {
	const showMenu = (menuItem: AdminMenuItem) => visibleMenuItems.includes(menuItem);

	return (
		<>
			{showMenu("institutions") && (
				<UserMenuItem
					data-testid="institutions-tab"
					onClick={() => {
						onMenuItemClick("institutions");
					}}
					Icon={InstitutionIcon}
				>
					{i18nPackage.t("coreComponents.userMenu.institutions")}
				</UserMenuItem>
			)}
			{showMenu("install") && (
				<UserMenuItem
					data-testid="install-tab"
					onClick={() => {
						onMenuItemClick("install");
					}}
					Icon={InstallIcon}
				>
					{i18nPackage.t("coreComponents.userMenu.install")}
				</UserMenuItem>
			)}
			{showMenu("accountManager") && (
				<UserMenuItem
					data-testid="accountManager-tab"
					onClick={() => {
						onMenuItemClick("accountManager");
					}}
					Icon={AccountManagerIcon}
				>
					{i18nPackage.t("coreComponents.userMenu.accountManagers")}
				</UserMenuItem>
			)}
			{showMenu("applications") && (
				<UserMenuItem
					data-testid="applications-tab"
					onClick={() => {
						onMenuItemClick("applications");
					}}
					Icon={ApplicationsIcon}
				>
					{i18nPackage.t("coreComponents.userMenu.applications")}
				</UserMenuItem>
			)}
			{showMenu("proctor") && (
				<UserMenuItem
					data-testid="proctor-tab"
					onClick={() => {
						onMenuItemClick("proctor");
					}}
					Icon={LiveProctoringIcon}
				>
					{i18nPackage.t("coreComponents.userMenu.liveProctoring")}
				</UserMenuItem>
			)}
			{showMenu("feedback") && (
				<UserMenuItem
					data-testid="feedback-tab"
					onClick={() => {
						onMenuItemClick("feedback");
					}}
					Icon={FeedbackIcon}
				>
					{i18nPackage.t("coreComponents.userMenu.feedback")}
				</UserMenuItem>
			)}
			{showMenu("events") && (
				<UserMenuItem
					data-testid="events-tab"
					onClick={() => {
						onMenuItemClick("events");
					}}
					Icon={EventsIcon}
				>
					{i18nPackage.t("coreComponents.userMenu.events")}
				</UserMenuItem>
			)}
			{showMenu("pendingInstitutionDeletion") && (
				<UserMenuItem
					data-testid="pendingInstitutionDeletion-tab"
					onClick={() => {
						onMenuItemClick("pendingInstitutionDeletion");
					}}
					Icon={DisabledInstitutionIcon}
				>
					{i18nPackage.t("coreComponents.userMenu.disabledInstitutions")}
				</UserMenuItem>
			)}
			{showMenu("auditLogs") && (
				<UserMenuItem
					data-testid="auditLog-tab"
					onClick={() => {
						onMenuItemClick("auditLogs");
					}}
					// Don't have an icon for audit logs yet, so using feedback icon for now
					Icon={FeedbackIcon}
				>
					{i18nPackage.t("coreComponents.userMenu.auditLogs")}
				</UserMenuItem>
			)}
		</>
	);
}
